export const SHARED_ACCESS_CONFIG = {
  storageKey: 'mirage_secure_access_v2',
  endpoints: {
    status: '/api/secure-access/status',
    verify: '/api/secure-access/verify',
    logout: '/api/secure-access/logout'
  }
};
